import { useState, useEffect, useContext } from '@wordpress/element';
import { CampoInput } from '@componentsNew/Input/CampoInput';
import EstruturaPostContext from '@pages/DicasOtimizacao/Context/EstruturaPostContext';

function AltImagem({ nota, carregando }) {



  return (
    <CampoInput
      label={'ALT da Imagem'}
      nota={nota}
      carregando={carregando}
      campoEstrutura={'alt_imagem'}
    />
  );
}

export default AltImagem;
